module.exports = __webpack_public_path__ + "img/timeline_mainevent-4.aaf5c6fc.jpg";